// @Version: 1.0.1
import { Component, EventEmitter, Output, Input, OnDestroy, forwardRef, signal, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FC_ALL_TOGGLE, TYPE, YESNO } from './all-toggle-function.model';
import { IFieldItem, IFunction } from '../field-item.model';
import { FieldItemToggleService } from '../toggle/toggle.service';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';

@UntilDestroy()
@Component({
   selector: 'app-field-item-all-toggle-function',
   templateUrl: './all-toggle-function.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => FieldItemAllToggleFunctionComponent),
         multi: true
      },
      {
         provide: NG_VALIDATORS,
         useExisting: forwardRef(() => FieldItemAllToggleFunctionComponent),
         multi: true
      },
      FieldItemToggleService
   ],
   standalone: false
})

export class FieldItemAllToggleFunctionComponent implements OnDestroy, OnChanges, ControlValueAccessor, Validators  {

   public FC_ALL_TOGGLE = FC_ALL_TOGGLE; 
   public TRANSLATE_PATH = TRANSLATE_PATH;

   public done$$ = signal(false);
   
   public fgAllFunction: FormGroup = this.fb.group({});
   
   private fieldItem_: IFieldItem = {} as IFieldItem;

   @Input()
   get fieldItem (): IFieldItem {
      return this.fieldItem_;
   }
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value || {};
   }

   @Output() valueFunction: EventEmitter<IFunction> = new EventEmitter<IFunction>(); 
   @Output() isRequiredMarker: EventEmitter<boolean> = new EventEmitter<boolean>();

   get value (): string {
      return this.fgAllFunction.get(FC_ALL_TOGGLE.ALLTOGGLEFUNCTION)?.value ?? '';
   }


   constructor (private fb: FormBuilder, public sFieldItemToggle: FieldItemToggleService) { }
   ngOnChanges(changes: SimpleChanges): void {
      if (changes && changes.fieldItem &&  (JSON.stringify(changes.fieldItem.currentValue) != JSON.stringify(changes.fieldItem.previousValue))) {
         console.log("allToggle init")
         this.init(changes.fieldItem.currentValue);
         this.onValidationChange();
      }
   }
  
   ngOnDestroy (): void {
      this.reset();
   }

   //TODO: Kommentar wird erst entfernt wenn festgestellt wurde aus welchem Grund dieses entfernt wurde, weil es nicht mehr benötigt wird oder wurde es nur vergessen wieder einzufügen
   validate (control: AbstractControl): ValidationErrors | null {
      return null;
      //this.allQuestionFunctionForm.updateValueAndValidity( {emitEvent: true, onlySelf: true });
      //return this.allQuestionFunctionForm.valid ? null : this.allQuestionFunctionForm.errors;
   }

   writeValue (): void { 
   }

   registerOnChange (fn: any): void {
      this.onChange = fn
   }

   registerOnTouched (fn: any): void {
      this.onTouched = fn
   }

   registerOnValidatorChange? (fn: () => void): void {
      this.onValidationChange = fn;
   }

   private onTouched () { }
   private onChange (_: string) { }
   private onValidationChange () {};

   setDisabledState (isDisabled: boolean | undefined): void { 
      isDisabled ? this.fgAllFunction.disable(): this.fgAllFunction.enable();
   }

   private reset (): void {
      this.done$$.set(false);
      this.fgAllFunction = this.fb.group({value: null, disabled: false}, {validators: [], updateOn: 'change'});
      this.fieldItem_ = {} as IFieldItem;
      this.sFieldItemToggle.reset();
   }
   

   private init (fieldItem: IFieldItem): void {
      this.transformAttribute(fieldItem);
       this.initFormGroup(fieldItem);
       this.done$$.set(true);
   }

   private transformAttribute (fieldItem: IFieldItem): boolean {
      if (!fieldItem.attribute_1 || !fieldItem.attribute_2 || !fieldItem.attribute_3 ||!fieldItem.attribute_4) return true;
      if (fieldItem.required) this.sFieldItemToggle.required = fieldItem.required;

      this.sFieldItemToggle.createErrorMessages(fieldItem.attribute_5 || '');
      return this.sFieldItemToggle.createToggleButtons(this.fieldItem)
   }

   private initFormGroup (fieldItem: IFieldItem): boolean {
      this.fgAllFunction.addControl(FC_ALL_TOGGLE.ALLTOGGLEFUNCTION, this.fb.control(fieldItem.content));

      this.fgAllFunction.get(FC_ALL_TOGGLE.ALLTOGGLEFUNCTION)?.valueChanges.subscribe(value => {
         this.valueFunction.emit({type: TYPE.ALLTOGGLEFUNCTION, value: value ? (this.fieldItem.attribute_4 ?? YESNO.NO)  : (this.fieldItem.attribute_3) ?? YESNO.YES });
         this.onChange(this.value);
         this.onTouched();
      })

      return true;
   }
}
